import { pxChangeVw } from "@/utils";
import styles from "./index.module.scss";
type StyleType = {
  color?: string;
  fontSize?: string | number;
  [propname: string]: any;
};
export function getUnit(value: string) {
  const match = value.match(/^[\d.]+(?:px|vw|rem|em|%)$/);
  return match ? match[0] : null;
}
function containsPxUnit(str: string) {
  return /\d+px/.test(str);
}
export const renderIconFont = (
  iconName: string,
  style: StyleType = { color: "#fff", fontSize: "16px" },
  ...args: any[]
) => {
  Object.keys(style).forEach(key => {
    const value = style[key];
    if (containsPxUnit(value)) {
      style[key] = pxChangeVw(value);
    } else {
      style[key] = value;
    }
  });
  return <i className={`iconfont ${iconName + " " + styles.icon_font}`} style={style} {...args}></i>;
};

export const IconFont = ({ iconName, style = { color: "#fff", fontSize: "16px" }, ...args }: any) => {
  Object.keys(style).forEach(key => {
    const value = style[key];
    if (containsPxUnit(value)) {
      style[key] = pxChangeVw(value);
    } else {
      style[key] = value;
    }
  });
  return <i className={`iconfont ${iconName + " " + styles.icon_font}`} style={style} {...args}></i>;
};
